import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { AssessmentService } from 'src/app/modules/evaluations/assessment/services/assessment.services';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SVGIcon, plusIcon } from '@progress/kendo-svg-icons';
import { ReferenceStore } from 'src/app/stores/reference.store';
import {
  EI_EXCLUDED_REASON_IDS,
  PRE_SCHOOL_ALLOWED_REASON_IDS,
} from '../../constants/reason-for-delays-contants';
import { StudentDetails } from 'src/app/shared/interfaces/student-details';

@Component({
    selector: 'app-reason-for-delay',
    templateUrl: './reason-for-delay.component.html',
    styleUrls: ['./reason-for-delay.component.scss'],
    standalone: false
})
export class ReasonForDelayComponent implements OnInit {
  @Input() referralsk: string;
  @Input() evalutionSk: string;
  @Input() title: string;
  @Input() iepFormSk: string;
  @Input() studentDetails: StudentDetails;
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  reasonForDelay: IReferenceData[];
  form: FormGroup;
  loadSpinner: boolean = true;
  svgPlus: SVGIcon = plusIcon;
  readonly reasonForDelayStageId: number = 3;
  readonly reasonForDelayFilterStageId: number = 4;

  constructor(
    private referenceStore: ReferenceStore,
    private fb: FormBuilder,
    // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
    private assessmentService: AssessmentService<any>
  ) {
    this.loadSpinner = true;
  }

  ngOnInit(): void {
    this.referenceStore.reasonForDelay$.subscribe((data: IReferenceData[]) => {
      this.reasonForDelay = this.filterReasonForDelayOptions(data);
      this.loadSpinner = false;
    });

    const formArray: FormArray = new FormArray([]);
    formArray.push(
      this.fb.group({
        reasonForDelayId: ['', Validators.required],
        description: ['', Validators.required],
        caseActionSk: [this.evalutionSk ? this.evalutionSk : this.iepFormSk],
        stageId: [
          this.evalutionSk
            ? this.reasonForDelayStageId
            : this.reasonForDelayFilterStageId,
        ],
      })
    );
    this.form = this.fb.group({
      reasons: formArray,
    });
  }

  // Function to filter reasonForDelay options
  filterReasonForDelayOptions(
    reasonForDelayOptions: IReferenceData[]
  ): IReferenceData[] {
    if (!this.studentDetails) return reasonForDelayOptions;

    // Scenario 1: If eiId is present
    if (this.studentDetails.eiId) {
      return reasonForDelayOptions.filter(
        (option: IReferenceData) =>
          !EI_EXCLUDED_REASON_IDS.includes(Number(option.id))
      );
    }

    // Scenario 2: If eiId is null and isPreSchool is true
    if (this.studentDetails.eiId === null && this.studentDetails.isPreSchool) {
      return reasonForDelayOptions.filter((option: IReferenceData) =>
        PRE_SCHOOL_ALLOWED_REASON_IDS.includes(Number(option.id))
      );
    }

    return reasonForDelayOptions;
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  submit(): void {
    this.loadSpinner = true;
    if (this.evalutionSk) {
      this.submitReasonForDelay(this.evalutionSk);
    } else {
      this.submitReasonForDelay(this.iepFormSk);
    }
  }

  submitReasonForDelay(id: string): void {
    this.assessmentService
      .submitReasonForDelay(id, this.reasons.value)
      .subscribe(() => {
        this.close.emit(true);
        this.loadSpinner = false;
      });
  }

  addReasonForDelay(): void {
    this.reasons.push(
      this.fb.group({
        reasonForDelayId: ['', Validators.required],
        description: ['', Validators.required],
        caseActionSk: [this.evalutionSk ? this.evalutionSk : this.iepFormSk],
        stageId: [
          this.evalutionSk
            ? this.reasonForDelayStageId
            : this.reasonForDelayFilterStageId,
        ],
      })
    );
  }

  get reasons(): FormArray {
    return this.form?.get('reasons') as FormArray;
  }
}
